import { useConfigurationQuery } from 'App/actions/api/configuration';
import { useUserQuery } from 'App/actions/api/user';
import { initializeFoundation } from 'App/actions/zitadel';
import { useLogout } from 'App/api/auth';
import { useAuth } from 'App/context/AuthContext';
import { FOUNDATION } from 'config/features';
import { useCallback, useEffect } from 'react';
import { useOrganizationShortName } from 'store/hooks/useOrganizationShortName';

import Initialize from './Initialize';

const EMPTY_USER = {};

const InitializeContainer = props => {
  const { isSuccess, isError } = useConfigurationQuery();
  const configurationInitialized = isSuccess || isError;
  const { data: user, isError: userError } = useUserQuery();
  const organizationShortName = useOrganizationShortName();
  const { token, invalidRoles, setToken, setInvalidRoles } = useAuth();
  const logout = useLogout();
  const initializeFoundationCallback = useCallback(
    () => initializeFoundation({ setToken, setInvalidRoles }),
    [setToken, setInvalidRoles]
  );

  useEffect(() => {
    if (userError && !user && !FOUNDATION) {
      logout();
    }
  }, [userError, user, logout]);

  return (
    <Initialize
      {...props}
      configurationInitialized={configurationInitialized}
      user={user ?? EMPTY_USER}
      organizationShortName={organizationShortName}
      token={token}
      invalidRoles={invalidRoles}
      initializeFoundation={initializeFoundationCallback}
    />
  );
};

export default InitializeContainer;
